import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class IdleService {
  onIdle(timeout: number): Observable<boolean> {
    return Observable.merge(
      Observable.timer(5000),
      Observable.fromEvent(window, 'mousemove'),
      Observable.fromEvent(window, 'resize'),
      Observable.fromEvent(document, 'keydown')
    )
      .switchMap(() => Observable.timer(timeout * 1000))
      .map(() => true);
  }

  onInterval(timeout: number): Observable<boolean> {
    return Observable.interval(timeout * 1000)
      .map(() => true);
  }

  minutes(minutes: number) {
    return minutes * 60;
  }

  hours(hours: number) {
    return hours * this.minutes(60);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/services/idle.service.ts